import { Component, Input, Output, EventEmitter } from '@angular/core';

import { NG_VALUE_ACCESSOR, NG_VALIDATORS, NG_ASYNC_VALIDATORS, ValidatorFn, AsyncValidatorFn } from '@angular/forms';
import { ControlContainer, FormGroup, FormBuilder } from '@angular/forms';
import { Inject, Optional, Host, SkipSelf } from '@angular/core';
import { ValueAccessorValidatedBase } from '@shared/src/components/core/form/value-accessor-validated';
import { forwardRef } from '@angular/core';
import { ValueControlCtrl } from '@shared/src/dtos/core/valuecontrol/ValueControlCtrl';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { HomeController } from '@shared/src/public-api';

@Component({
  selector: 'value-control-component',
  templateUrl: './value.control.component.html',
  styleUrls: ['./value.control.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ValueControlComponent), multi: true }
  ]
})

export class ValueControlComponent extends ValueAccessorValidatedBase<any, any> {

  createForm(validators: ValidatorFn[], asyncvalidators: AsyncValidatorFn[]) {
    this.rFormInput = this.fb.group({
      dtpvalidator: ['', validators, asyncvalidators]
    });
  }

  isValid(value: any): boolean {
    return true;
  }

  rFormInput: FormGroup;

  valueTextUpdate = new Subject<string>();

  constructor(
    @Optional() @Host() @SkipSelf() controlContainer: ControlContainer,
    @Optional() @Inject(NG_VALIDATORS) validators: ValidatorFn[],
    @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: AsyncValidatorFn[],
    private fb: FormBuilder
  ) {
    super(controlContainer, validators, asyncValidators);
    
    this.valueTextUpdate.pipe(
          debounceTime(HomeController.DEFAULT_BOUNCE_BUTTON_TIME),
          distinctUntilChanged())
          .subscribe(value => {
           this.onValueChanged(value);
      });
  }

  @Input() public valueCtrl: ValueControlCtrl;
  @Input() public color: string = 'primary';
  @Input() public readonly: boolean = false;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();


  public identifier = 'value-control-' + identifier++;

  externalValue(value: any): any {
    return value;
  }
  internalValue(value: any): any {
    return value;
  }

  onValueChanged(e) {
    if (e && e.detail) {
      this.value = e.detail.checked;
    }else if (e && e.option != null){
      this.value = e.option.value;
    }
    this.valueChanged.next(this.externalValue(this.value));
  }

  public pretty(value: any): string {
    return JSON.stringify(value);
  }
}

let identifier = 0;